import { render, staticRenderFns } from "./FPButtonLoader.vue?vue&type=template&id=1fedd3df"
import script from "./FPButtonLoader.vue?vue&type=script&lang=js"
export * from "./FPButtonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports